import React from 'react'
import List from './components/UserList'

const Route = () => ({
  index: true,
  path: '',
  element: <List />,
})

export default Route
